import { CardRow } from 'components/CardRow';
import { NumberSpinner } from 'components/Field/NumberSpinner';
import { ICONS } from 'components/Icon';
import { theme } from 'lib/theme';
import React from 'react';

interface Props {
  onChange?: (value?: number | null) => void;
  onChangeAsString?: (value: string) => void;
  label?: string;
  value?: number;
  clearable?: boolean;
  showFieldTypeIcon?: boolean;
}

export const NumberRow: React.FC<Props> = ({
  label,
  onChange,
  onChangeAsString,
  clearable = true,
  value,
  showFieldTypeIcon = true,
}) => {
  const [spinnerKey, setSpinnerKey] = React.useState(0);
  const handleChange = React.useCallback(
    (newValue: number | null) => {
      onChange?.(newValue);
      onChangeAsString?.(newValue !== null ? newValue.toString() : '');
    },
    [onChange, onChangeAsString],
  );

  const handleClear = React.useCallback(() => {
    handleChange(null);
    setSpinnerKey(Math.round(Math.random() * 1000));
  }, [handleChange]);

  const valueInLabel = !label;
  const hasValue = !!value || value === 0;
  const finalLabel = label;

  return (
    <CardRow
      style={{ backgroundColor: 'white' }}
      navigationType={showFieldTypeIcon ? 'input-number' : undefined}
      label={finalLabel}
      labelColor={
        !hasValue && valueInLabel ? theme.colors.placeholder : undefined
      }
      actionIcon={ICONS.CircleXmarkLight}
      onAction={clearable && (value || value === 0) ? handleClear : undefined}
      contentStyle={{ paddingVertical: 0 }}
    >
      <NumberSpinner
        key={spinnerKey}
        onChange={handleChange}
        value={hasValue ? value : undefined}
        minValue={0}
      />
    </CardRow>
  );
};
